import { TCryptoCurrency, TFiatCurrency } from 'nexchange-service/module/coins'

enum ETierName {
    Tier0 = 'Tier 0',
    Tier1 = 'Tier 1',
    Tier2 = 'Tier 2',
    Tier3 = 'Tier 3',
    Tier4 = 'Tier 4',
}

enum KycDocumentApprovalStatus {
    APPROVED = 'APPROVED',
    UNDEFINED = 'UNDEFINED',
    REJECTED = 'REJECTED',
}

interface ITradeLimit {
    message: string
    out_of_limit: boolean
    days: number
    amount: number
    currency: TCryptoCurrency | TFiatCurrency
    total_amount: number
}
interface ITier {
    name: ETierName
    upgrade_note: string
    upgrade_documents: Array<string>
}

interface ILimitsMessage {
    trade_limits: Array<ITradeLimit>
    tier: ITier
    whitelisted_addresses: Array<string>
    whitelisted_addresses_info: object
}

interface IKycDetailsApiDto {
    id_document_status: string
    util_document_status: string
    selfie_document_status: string
    whitelist_selfie_document_status: string
    identity_token: string | null
    residence_document_status: string
    user_visible_comment: string | null

    is_verified: boolean
    out_of_limit: boolean

    limits_message: ILimitsMessage
}

export type { IKycDetailsApiDto, ILimitsMessage, ITradeLimit, ITier }
export { ETierName, KycDocumentApprovalStatus }
